import { fetchRates } from '@/api/web'

const search = async ({ commit }, rateSearchRequest) => {
  let response = await fetchRates(rateSearchRequest)
  commit('SET_RATES', response)
}

export default {
  search
}



// WEBPACK FOOTER //
// ./src/store/modules/rates/actions.js